export default __webpack_public_path__ + "static/media/flatware.0db82dc9.webp";